const questionType = {
  1: "单选题",
  2: "多选题",
  3: "判断题",
  4: "不定项选择题",
  5: "计算分析题",
  6: "简答题",
  7: "综合题",
  8: "计算问答题",
  9: "案例分析题",
  10: "综合分析题",
  11: "计算题",
  12: "综合分析题（不定项）",
  13: "计算题（不定项）"
};

const questionIndex = {
  1: "A",
  2: "B",
  3: "C",
  4: "D",
  5: "E",
  6: "F",
  7: "G",
  8: "H",
  9: "I",
  10: "G",
  11: "K"
};

const numberIndex = {
  1: "一",
  2: "二",
  3: "三",
  4: "四",
  5: "五",
  6: "六",
  7: "七",
  8: "八",
  9: "九",
  10: "十",
  11: "十一",
  12: "十二",
  13: "十三",
  14: "十四",
  15: "十五",
  16: "十六",
  17: "十七",
  18: "十八",
  19: "十九",
  20: "二十"
};

const needAlertRoute = [
  '/login',
  '/test'
]

export default { questionType, questionIndex,numberIndex,needAlertRoute };


// WEBPACK FOOTER //
// ./src/common/js/data.js